import { MenuLeaf } from '../../../types/types';

export const isTrailingSeparator = (
  items: MenuLeaf[],
  index: number
): boolean => items[index]?.type === 'separator' && index === items.length - 1;
